/* eslint-disable import/prefer-default-export */
import { isEmpty } from 'lodash'
import { useCallback, useMemo } from 'react'

import { TestimonialsFilterInput } from '~generated/types'
import { pickValidFields } from '~lib/helpers/pickValidFields'
import usePersistentState from '~lib/hooks/usePersistentState'

type UsePersistentTestimonialsFilterParams = {
  key: string
  defaultState: TestimonialsFilterInput
}

export function usePersistentTestimonialsFilter({ key, defaultState }: UsePersistentTestimonialsFilterParams) {
  const [persistentFilter, setPersistentFilter] = usePersistentState<TestimonialsFilterInput>({
    key: `testimonialsFilter:${key}`,
    defaultState,
  })

  const handleApplyFilter = useCallback(
    (nextFilter: Partial<TestimonialsFilterInput>) => {
      setPersistentFilter((prevFilter) => ({ ...prevFilter, ...nextFilter }))
    },
    [setPersistentFilter]
  )

  const handleResetFilter = useCallback(() => {
    setPersistentFilter({})
  }, [setPersistentFilter])

  const filter = useMemo<TestimonialsFilterInput>(() => {
    return pickValidFields(persistentFilter, [
      {
        key: 'query',
        validator: (v) => !isEmpty(v),
      },
      {
        keys: ['tagIds'],
        validator: (v) => !isEmpty(v),
      },
    ])
  }, [persistentFilter])

  return [filter, handleApplyFilter, handleResetFilter] as const
}
